import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import StudentRoutinePage from "./StudentRoutinePage";
import TeacherRoutinePage from "./TeacherRoutinePage";


const RoutinePage = () => {
  const { t } = useTranslation();
  const user = useSelector((state: RootState) => state.authSlice.user);
  console.log("user", user);
  const role = useMemo(() => user?.role, [user?.role]);


  switch (role) {
    case "student":
      return <StudentRoutinePage />;
    case "teacher":
      return <TeacherRoutinePage />;
    default:
      return <StudentRoutinePage />;
  }
};

export default RoutinePage;